module.exports = __webpack_public_path__ + "static/img/digital02.79202fa2.png";